// Firefly Club — shared behavior
document.addEventListener('DOMContentLoaded', function () {

  // ---- footer year (any element with data-ff-year) ----
  document.querySelectorAll('[data-ff-year]').forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });

  // ---- plan / box selector (per section instance, so multiple sections can coexist) ----
  document.querySelectorAll('[data-ff-plans]').forEach(function (group) {
    var plans = Array.from(group.querySelectorAll('.ff-plan'));
    var summary = group.parentElement.querySelector('[data-ff-summary]');
    if (!summary) return;
    var selName = summary.querySelector('[data-ff-sel-name]');
    var selPrice = summary.querySelector('[data-ff-sel-price]');
    var actionSlot = summary.querySelector('[data-ff-action-slot]');

    function selectPlan(plan) {
      if (plan.getAttribute('aria-disabled') === 'true') return;
      plans.forEach(function (p) { p.setAttribute('aria-selected', 'false'); });
      plan.setAttribute('aria-selected', 'true');
      if (selName) selName.textContent = plan.dataset.name;
      if (selPrice) selPrice.textContent = plan.dataset.price;
      if (actionSlot) {
        var tpl = plan.querySelector('template[data-ff-custom-html]');
        var customHtml = tpl ? tpl.innerHTML : '';
        var hideButton = plan.getAttribute('data-hide-button') === 'true';
        if (customHtml) {
          actionSlot.innerHTML = customHtml;
        } else if (hideButton) {
          actionSlot.innerHTML = '';
        } else {
          var cta = plan.dataset.cta || 'Add to cart';
          var href = plan.dataset.href || '#';
          actionSlot.innerHTML = '<a href="' + href + '" class="ff-btn ff-btn-primary" data-ff-add-btn>' + cta + ' \u2192</a>';
        }
      }
    }

    plans.forEach(function (plan) {
      plan.addEventListener('click', function () { selectPlan(plan); });
      plan.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPlan(plan); }
      });
    });
  });

  // ---- accordion chevron state handled natively by <details>; nothing needed ----
});
